/* eslint-disable no-useless-escape */
export function getFromCache(itemName: string) {
    // const item = Cookies.get(itemName);
    const item = localStorage.getItem(itemName);
    const numPatt = new RegExp(/^\d+$/);
    const jsonPatt = new RegExp(/[\[\{].*[\}\]]/);

    if (item) {
        if (jsonPatt.test(item)) {
            return JSON.parse(item);
        }
        else if (numPatt.test(item)) {
            return parseFloat(item);
        }
        else {
            return item;
        }
    }
    else {
        return null;
    }

}

export function saveToCache(itemName: string, item: object) {
    if (typeof item === 'object') {
        // Cookies.set(itemName, JSON.stringify(item));
        localStorage.setItem(itemName, JSON.stringify(item));
    } else {
        // Cookies.set(itemName, item);
        localStorage.setItem(itemName, item);
    }
}

export function removeFromCache(itemName: string) {
    // Cookies.remove(itemName);
    localStorage.removeItem(itemName);
}

// Plot drag mode persistence helpers
export function savePlotDragMode(dragMode: 'zoom' | 'pan') {
    localStorage.setItem('plotDragMode', dragMode);
}

export function getPlotDragMode(): 'zoom' | 'pan' {
    return (localStorage.getItem('plotDragMode') as 'zoom' | 'pan') || 'zoom';
}

export function removePlotDragMode() {
    localStorage.removeItem('plotDragMode');
}